import { useState, useEffect } from "react";

export const palette = {
  bg: "#F8FAFC",
  bgSidebar: "#0F1E36", // Deep Navy
  text: "#1E293B",
  textSoft: "#64748B",
  textInverse: "#FFFFFF",
  gold: "#C5A059", // Gorjana Gold
  goldLight: "#F5F0E6",
  navyLight: "#1E3A8A",
  line: "#E2E8F0",
  success: "#059669",
};

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) setMatches(media.matches);
    const listener = () => setMatches(media.matches);
    media.addListener(listener);
    return () => media.removeListener(listener);
  }, [matches, query]);
  return matches;
};

export const styles = {
  // Centralized Font Stacks
  fonts: {
    sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    serif: '"Playfair Display", Georgia, "Times New Roman", serif',
    mono: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace',
  },

  container: {
    display: "flex",
    height: "100vh",
    width: "100vw",
    backgroundColor: palette.bg,
    color: palette.text,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    overflow: "hidden",
    position: "relative",
  },
  sidebarDesktop: {
    width: "280px",
    backgroundColor: palette.bgSidebar,
    display: "flex",
    flexDirection: "column",
    padding: "32px 24px",
    zIndex: 20,
    color: palette.textInverse,
    boxShadow: "4px 0 24px rgba(0,0,0,0.05)",
    height: "100%",
  },
  sidebarMobile: {
    position: "fixed",
    inset: "0 0 0 0",
    backgroundColor: palette.bgSidebar,
    padding: "24px",
    zIndex: 50,
    display: "flex",
    flexDirection: "column",
    width: "85%",
    maxWidth: "320px",
    boxShadow: "10px 0 30px rgba(0,0,0,0.5)",
    transition: "transform 0.3s ease",
  },
  navItem: (active) => ({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px",
    borderRadius: "8px",
    cursor: "pointer",
    backgroundColor: active ? "rgba(255, 255, 255, 0.1)" : "transparent",
    color: active ? "#FFFFFF" : "rgba(255,255,255,0.6)",
    borderLeft: active ? `3px solid ${palette.gold}` : "3px solid transparent",
    transition: "all 0.2s ease",
    fontWeight: active ? 600 : 500,
    fontSize: "14px",
    letterSpacing: "0.02em",
  }),
  tabBtn: (active, mode) => ({
    flex: 1,
    padding: "20px",
    textAlign: "center",
    cursor: "pointer",
    borderBottom: active
      ? `4px solid ${mode === "work" ? palette.bgSidebar : palette.gold}`
      : `1px solid ${palette.line}`,
    color: active
      ? mode === "work"
        ? palette.bgSidebar
        : palette.gold
      : palette.textSoft,
    fontWeight: active ? 700 : 500,
    fontSize: "14px",
    textTransform: "uppercase",
    letterSpacing: "0.15em",
    transition: "all 0.2s ease",
    backgroundColor: active ? "#FFFFFF" : "#F8FAFC",
  }),
  modalOverlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(15, 30, 54, 0.7)",
    backdropFilter: "blur(4px)",
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  modalContent: {
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",
    width: "100%",
    maxWidth: "1000px",
    maxHeight: "90vh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 20px 50px -10px rgba(0, 0, 0, 0.3)",
  },
};
